import { createTheme } from "@mui/material/styles";

export const LightTheme = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: "rgba(60,184,121,1)",
			contrastText: "rgba(255,255,255,1)",
		},
		secondary: {
			main: "rgba(60,184,121,1)",
		},
		tertiary: {
			main: "rgba(0,0,0,1)",
		},
		destructive: {
			main: "rgba(161,51,51,1)",
			contrastText: "rgba(255,255,255,1)",
		},
		text: {
			primary: "rgba(0,0,0,0.87)",
		},
		appbar: {
			main: "rgba(49,74,131,1)",
		},
		statusbox: {
			main: "rgba(255,255,255,1)",
		},
		background: {
			default: "rgba(243,246,248,1)"
		},
		alert: {
			main: "rgba(255, 255, 255, 1)"	
		}
	},
	components: {
		MuiButton: {
			styleOverrides: {
				outlined: {
					backgroundColor: "rgba(255,255,255,1)",
				},				
			},
		},
		MuiTableRow: {
			styleOverrides: {
				root: {
					"&:nth-of-type(even)": {
						backgroundColor: "rgba(243,246,248,0.5)",
					},
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				head: { 
					backgroundColor: "rgba(243,246,248,1)",
				},
			},
		},
	},
});

export const DarkTheme = createTheme({
	palette: {
		mode: "dark",
		primary: {
			main: "rgba(60,184,121,1)",
			contrastText: "rgba(255,255,255,1)",
		},
		secondary: {
			main: "rgba(60,184,121,1)",
		},
		tertiary: {
			main: "rgba(0,0,0,1)",
		},
		destructive: {
			main: "rgba(161,51,51,1)",
			contrastText: "rgba(255,255,255,1)",
		},
		appbar: {
			main: "rgba(18,18,18,1)",
		},
		statusbox: {
			main: "rgba(0,0,0,1)",
		},
		background: {
			default: "rgba(18,18,18,1)",
		},
		alert: {
			main: "rgba(0, 0, 0, 1)"	
		}
	},
	components: {
		MuiButton: {
			styleOverrides: {
				outlined: {
					backgroundColor: "rgba(0,0,0,1)",
				},
			},
		},
		MuiTableRow: {
			styleOverrides: {
				root: {
					"&:nth-of-type(even)": {
						backgroundColor: "rgba(18,18,18,1)",
					},
				},
			},
		},
	},
});
